<template>
    <div
        class="container flex flex-col tablet:flex-row mb-32">
        <!--Title-->
        <div class="related-article-title uppercase text-white tablet:text-sm tablet:w-2/12 phone:mb-8 phone:mr-32">
            <hr class="text-gold-500 mr-4">
            <h2
                class="pt-6"
                v-text="labels.relatedArticleTitle" />
        </div>
        <!--List-->
        <div class="flex flex-col tablet:flex-row w-full">
            <list-post-item
                v-for="(post, index) in blogPosts"
                :key="index"
                :blog-post="post"
                :even-list-item="(index+1)%2 === 0"
                :labels="labels"
                class="mb-20"
                :related-posts="true"
            />
        </div>
    </div>
</template>

<script>
import ListPostItem from '@web/components/Blog/ListPostItem';

export default {
  name: 'ListRelatedPosts',
  components: { ListPostItem },
  props: {
    labels: {
      type: Object,
      required: true,
    },
    blogPosts: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
